import React, { useEffect } from "react";

import "./InputField.scss";
import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import getStyles from "./getStyles";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const InputField = (props: any) => {
  const classes = getStyles();

  return (
    <div className={`InputField--input-container ${props.containerClassName}`}>
      <div className="InputField--input-label">{props.fieldName}</div>
      <FormControl error>
        <div className="InputField--textFieldContainer">
          <TextField
            label={props.label}
            disabled={props.disabled}
            className={`${classes.inputField} ${props.textFieldClassName}`}
            type={props.type}
            variant="outlined"
            onFocus={e => e.target.select()}
            value={props.value}
            inputProps={props.inputProps}
            placeholder={props.placeHolder}
            onChange={props.onChange}
            error={props.errorOutline}
            multiline={props.multiline}
            rows={props.multilineRows}
          />
          {props.clickedActionButton && !props.errorOutline ? (
            <CheckCircleIcon className="InputField--checkIcon" />
          ) : props.errorOutline ? (
            <CancelIcon className="InputField--cancelIcon" />
          ) : (
            <></>
          )}
        </div>
        <FormHelperText
          className={`${classes.errorMsg} ${props.errorMessageClassName}`}
        >
          {props.errorMessage}
        </FormHelperText>
      </FormControl>
    </div>
  );
};

export default InputField;
